import React from 'react';
import PropTypes from 'prop-types';
import { Card, Alert } from 'react-bootstrap';

/**
 * ReferenceFilesSection - Placeholder component for reference file configuration
 * 
 * @param {string} customerId - The ID of the customer
 */
const ReferenceFilesSection = ({ customerId }) => {
  return (
    <div>
      <h5 className="mb-3">Reference File Configuration</h5>
      <Card>
        <Card.Body>
          <Alert variant="info" className="mb-0">
            <Alert.Heading>Coming Soon</Alert.Heading>
            <p className="mb-0">
              Reference file configuration for customer {customerId} will be available in a future release.
            </p>
          </Alert>
        </Card.Body>
      </Card>
    </div>
  );
};

ReferenceFilesSection.propTypes = {
  customerId: PropTypes.string.isRequired
};

export default ReferenceFilesSection;
